<template>
    <div class="pedir-taxi--container">
        <div class="pedir-taxi-waiting--wrapper">
            <div class="logo">
                <img class="logo--img" :src="$img('taxi-request.png')" />
                <div class="logo--text">{{ searchingText }}</div>
                <div class="logo--text text-time" v-if="timeToCancel > 0">{{ toTime(this.timeToCancel) }}</div>
            </div>
        </div>
        <div class="btn-container">
            <transition name="fade">
                <button class="btn btn-secondary btn-lg btn-heavy" @click="onCancelTripRequest" v-show="isCancelVisible" :disabled="loading" v-lang.cancelar>
                    Cancelar
                </button>
            </transition>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import bus from '@/services/bus-event';
import dialogs from '@/services/dialogs';
import { setInterval, clearInterval } from 'timers';

export default {
    name: 'passengerTripRequest',
    props: [

    ],
    data () {
        return {
            isCancelVisible: false,
            searchingTextPoints: 0,
            loading: false,
            mensajeEsperaTimer: 0,
            timeToCancel: 0
        };
    },
    computed: {
        ...mapGetters({
            logged: 'auth/checkLogin',
            user: 'auth/user',
            isMobile: 'device/isMobile',
            position: 'geolocation/actual',
            trip: 'passenger/actualTrip',
            settings: 'company/config'
        }),
        searchingText () {
            let text = this.translate('buscando');
            for (let i = 0; i < this.searchingTextPoints; i++) {
                text = text + '.';
            }
            return text;
        }
    },
    mounted () {
        this.language = this.$getLang();
        let vm = this;
        let waitingTime = 10;
        let interval = 0;
        if (this.settings.tiempo_espera_custom) {
            waitingTime = parseInt(this.settings.tiempo_espera_custom, 10);
        }
        if (this.settings.modulo_cuenta_regresiva_solicitar) {
            this.timeToCancel = waitingTime;
            interval = setInterval(() => {
                if (this.timeToCancel > 0) {
                    this.timeToCancel = this.timeToCancel - 1;
                } else {
                    clearInterval(interval);
                }
            }, 1000);
        }
        setTimeout(() => {
            this.isCancelVisible = true;
        }, waitingTime * 1000);
        console.log('mostrar_mensaje_espera', this.settings.mostrar_mensaje_espera);
        if (this.settings.mostrar_mensaje_espera) {
            this.mensajeEsperaTimer = setTimeout(() => {
                if (vm.trip && vm.trip.frontState === vm.TRIP_STATE.PENDING) {
                    let msg = this.settings.mostrar_mensaje_espera.mensaje;
                    if (this.settings.mostrar_mensaje_espera.i18n) {
                        msg = this.settings.mostrar_mensaje_espera.i18n[this.language];
                    }
                    console.log('mostrar_mensaje_espera', msg);
                    dialogs.message(msg, { duration: 10 });
                }
            }, this.settings.mostrar_mensaje_espera.tiempo * 1000);
        }
        setTimeout(this.addTextPoints, 500);
    },
    methods: {
        ...mapActions({
            cancelTrip: 'passenger/cancelTrip'
        }),
        onCancelTripRequest () {
            console.log('on CANCELADO BUSCANDO VIAJE');
            this.loading = true;
            if (this.mensajeEsperaTimer) {
                window.clearTimeout(this.mensajeEsperaTimer);
            }
            let data = Object.assign({
                comentario: 'CANCELADO BUSCANDO VIAJE',
                cancelar_buscando: true
            }, this.position);
            this.cancelTrip(data).catch(() => {
                this.loading = false;
                bus.emit('trip_canceled');
            });
        },
        addTextPoints () {
            if (this.searchingTextPoints === 3) {
                this.searchingTextPoints = 0;
            } else {
                this.searchingTextPoints++;
            }
            setTimeout(this.addTextPoints, 500);
        },
        toTime (secs) {
            var hours = Math.floor(secs / 3600);
            var minutes = Math.floor((secs - (hours * 3600)) / 60);
            var seconds = secs - (hours * 3600) - (minutes * 60);

            // if (hours   < 10) {hours   = "0"+hours;}
            if (minutes < 10) { minutes = '0' + minutes; }
            if (seconds < 10) { seconds = '0' + seconds; }
            return /* hours+':'+ */ minutes + ':' + seconds;
        }
    }
};
</script>

<style scoped>
.pedir-taxi-waiting--wrapper {
    height: 100%;
    background-color: var(--pedir-taxi-background);
}
.pedir-taxi--container {
    height: 100%;
    width: 100%;
    z-index: 2;
    position: absolute;
}
.logo {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -120px;
    margin-left: -80px;
}
.logo--img {
    width: 160px;
}
.logo--text {
    display: block;
    text-align: left;
    font-weight: bold;
    text-transform: uppercase;
    margin-top: 1em;
    font-size: 1.25em;
    margin-left: 1.5em;
}
.btn-container {
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1;
        width: 100%;
        padding: 1em;
}
.text-time {
    text-align: center;
    margin: 0;
    font-size: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/passenger/RequestWaiting.vue